module.exports = __webpack_public_path__ + "assets/img/rar.df75fb73.svg";